var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-empty-record"},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_c('p',[_vm._v(_vm._s(_vm.$t('noMore')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }